export const SESSION_TIMEOUT_SECONDS = 60 * 60; // 1 hour
//# sourceMappingURL=constants.js.map